<div class="page-content-wrapper">
  <div class="filter-forms-nav">
    <div class="page-header">
      <button class="back-btn" (click)="goBack()" title="{{'Back' | translate}}">
        <span class="material-symbols-outlined">arrow_back</span>
      </button>

      <div class="header-main">
        @if (selectedOrg?.name) {
          <div class="header-breadcrumb">
            {{selectedOrg.name}}
          </div>
        }
        <div class="node-select" (clickOutside)="isNodeSelectOpen ? toggleNodeSelect(false) : null">
          <button type="button" class="header-title-row node-select-trigger" [class.open]="isNodeSelectOpen"
            (click)="toggleNodeSelect()" title="{{'Switch node' | translate}}">
            <span class="status-dot" [class.status-online]="nodeDetails?.statusId === 1"></span>
            {{nodeDetails?.endpointName}}
            <span class="material-symbols-outlined node-select-icon">expand_more</span>
          </button>

          @if (isNodeSelectOpen) {
            <div class="node-select-menu">
              <div class="node-select-search">
                <span class="material-symbols-outlined">search</span>
                <input type="text" [placeholder]="'Search nodes...' | translate" [value]="nodeSearchQuery"
                  (input)="onNodeSearch($any($event.target).value)">
              </div>
              <div class="node-select-list">
                @for (node of nodeSelectOptions; track node.id) {
                  <button type="button" class="node-select-option" [class.current]="node.id === endPointId" (click)="selectNode(node)">
                    <span class="node-select-text">
                      <span class="node-select-name">{{node.name}}</span>
                      @if (node.customObjectName) {
                        <span class="node-select-type">{{node.customObjectName}}</span>
                      }
                    </span>
                    @if (node.id === endPointId) {
                      <span class="material-symbols-outlined node-select-check">check</span>
                    }
                  </button>
                } @empty {
                  <div class="node-select-empty">{{'No nodes found' | translate}}</div>
                }
              </div>
            </div>
          }
        </div>
      </div>

      @if (headerReadingsList?.length > 0) {
        <div class="header-readings">
          @for (r of headerReadingsList; track trackByIndex($index)) {
            <div class="header-kpi">
              <span class="header-kpi-label">{{r.paramName | uppercase}} {{'Current' | translate}}</span>
              <span class="header-kpi-value">
                {{r.value}}@if (r.unit) {
                <span class="header-kpi-unit">{{r.unit}}</span>
              }
            </span>
          </div>
        }
      </div>
    }

    @if (highestActiveSeverity != null) {
      <div class="header-alert-badge">
        <span class="material-symbols-outlined">warning</span>
        <span class="header-alert-label">{{'Highest Active Severity' | translate}}</span>
        <app-severity-chip [severity]="highestActiveSeverity" [compact]="true"></app-severity-chip>
      </div>
    }
  </div>
</div>

<div class="workspace" [class.collapsed]="isPanelCollapsed">

  <!-- ---- CHART COLUMN ---- -->
  <div class="chart-col" #chartContainer>
    <div class="chart-toolbar">
      <div class="toolbar-group">
        <div class="param-dropdown-container" (clickOutside)="showParamsDialog ? hideParamsDropdown(false) : null">
          <button class="toolbar-btn toolbar-btn-primary" [class.active]="showParamsDialog" (click)="hideParamsDropdown()" title="{{'Add Parameter' | translate}}">
            <span class="material-symbols-outlined">add</span>
            {{'Parameters' | translate}}
            <span class="material-symbols-outlined dropdown-icon">expand_more</span>
          </button>

          @if (showParamsDialog) {
            <div class="modal-content">
              <div class="modal-content-inner">
                <div class="param-list-scroll">
                  @for (param of parameters; track trackById(i, param); let i = $index) {
                    @if (!param.hidden) {
                      <div class="checkboxes">
                        <div class="checkbox-td">
                          <label class="container">
                            <input
                              type="checkbox"
                              [checked]="param.selected"
                              [disabled]="param.id === selectedParameter?.parameterType"
                              (change)="updateParameterSelection(i, $event)">
                              <span class="checkmark"></span>
                              {{param.value}}
                            </label>
                          </div>
                        </div>
                      }
                    }
                  </div>
                  <div class="btns-div">
                    <button type="button" class="main-btn plot-btn" [disabled]="!canPlotParameters" (click)="plotParametersRecords()">
                      {{'Plot' | translate}}
                    </button>
                    <button type="button" class="main-btn plot-btn" (click)="cancelParametersRecords()">
                      {{'Cancel' | translate}}
                    </button>
                  </div>
                </div>
              </div>
            }
          </div>

          <button class="toolbar-btn toolbar-btn-outline" (click)="focusCompareTab()" title="{{'Compare Nodes' | translate}}">
            <span class="material-symbols-outlined">compare_arrows</span>
            {{'Compare Nodes' | translate}}
          </button>
          @if (compareNodes.length > 0) {
            <div class="toolbar-divider"></div>
          }
          <div class="node-chips-container">
            @for (node of compareNodes; track trackById($index, node)) {
              <span class="node-chip" [style.--chip-color]="node.color">
                <span class="chip-dot" [style.background-color]="node.color"></span>
                {{node.name}}
                <button class="chip-remove" (click)="removeCompareNode(node.id)" title="{{'Remove' | translate}}">
                  <span class="material-symbols-outlined">close</span>
                </button>
              </span>
            }
          </div>
        </div>

        <div class="toolbar-spacer"></div>

        <div class="toolbar-group toolbar-right">
          <div class="layers-menu-container" (clickOutside)="isLayersMenuOpen ? closeLayersMenu() : null">
            <button class="toolbar-btn" [class.toolbar-btn-primary]="isLayersMenuOpen || hasEnabledLayers" (click)="toggleLayersMenu()" title="{{'Layers' | translate}}">
              <span class="material-symbols-outlined">layers</span>
              {{'Layers' | translate}}
            </button>
            @if (isLayersMenuOpen) {
              <div class="layers-menu">
                <label class="layer-toggle-item">
                  <input type="checkbox" [checked]="showAlertPeriodsLayer" (change)="updateLayerToggle('alertPeriods', $event)">
                  <span>{{'Alert periods' | translate}}</span>
                </label>
                <label class="layer-toggle-item">
                  <input type="checkbox" [checked]="showNotificationMarkersLayer" (change)="updateLayerToggle('notifications', $event)">
                  <span>{{'Notifications sent' | translate}}</span>
                </label>
                <label class="layer-toggle-item">
                  <input type="checkbox" [checked]="showThresholdsLayer" (change)="updateLayerToggle('thresholds', $event)">
                  <span>{{'Parameter thresholds' | translate}}</span>
                </label>
                <label class="layer-toggle-item">
                  <input type="checkbox" [checked]="showNotesLayer" (change)="updateLayerToggle('notes', $event)">
                  <span>{{'Notes / annotations' | translate}}</span>
                </label>
                <label class="layer-toggle-item">
                  <input type="checkbox" [checked]="showMinMaxBandLayer" (change)="updateLayerToggle('minMaxBand', $event)">
                  <span>{{'Min/max band' | translate}}</span>
                </label>
                <label class="layer-toggle-item">
                  <input type="checkbox" [checked]="showMapLayer" (change)="updateLayerToggle('map', $event)">
                  <span>{{'Map (GPS location)' | translate}}</span>
                </label>
              </div>
            }
          </div>
          <button class="toolbar-btn" [class.toolbar-btn-primary]="isMultiAxisEnabled" (click)="toggleMultiAxis()" title="{{'Multi-axis' | translate}}">
            <span class="material-symbols-outlined">stacked_line_chart</span>
            {{'Multi-axis' | translate}}
          </button>
          <div class="yaxis-menu-container" (clickOutside)="isYAxisMenuOpen ? closeYAxisMenu() : null">
            <button class="toolbar-btn" [class.toolbar-btn-primary]="isYAxisMenuOpen" (click)="toggleYAxisMenu()" title="{{'Y-axis range' | translate}}">
              <span class="material-symbols-outlined">height</span>
              {{'Y-Range' | translate}}
            </button>
            @if (isYAxisMenuOpen) {
              <div class="yaxis-menu">
                @if (yAxisControls.length > 0) {
                  @for (control of yAxisControls; track trackByIndex($index)) {
                    <div class="yaxis-control">
                      <div class="yaxis-control-label">
                        <span>{{control.label || ('Axis' | translate)}}</span>
                        @if (control.manual) {
                          <span class="yaxis-manual-tag">{{'Manual' | translate}}</span>
                        }
                      </div>
                      <div class="yaxis-inputs">
                        <input #minInput type="number" class="yaxis-input" [value]="control.min" placeholder="{{'Min' | translate}}">
                        <input #maxInput type="number" class="yaxis-input" [value]="control.max" placeholder="{{'Max' | translate}}">
                      </div>
                      <div class="yaxis-actions">
                        <button class="btn-ghost" (click)="applyYAxisRange(control, minInput.value, maxInput.value)">{{'Apply' | translate}}</button>
                        <button class="btn-ghost" (click)="resetYAxisRange(control, minInput, maxInput)" [disabled]="!control.manual">{{'Reset' | translate}}</button>
                      </div>
                    </div>
                  }
                  <div class="yaxis-hint">{{'Drag or scroll on an axis to rescale it.' | translate}}</div>
                } @else {
                  <div class="yaxis-empty">{{'No active axes to adjust' | translate}}</div>
                }
              </div>
            }
          </div>
          <div class="yaxis-menu-container" (clickOutside)="isXAxisMenuOpen ? closeXAxisMenu() : null">
            <button class="toolbar-btn" [class.toolbar-btn-primary]="isXAxisMenuOpen" (click)="toggleXAxisMenu()" title="{{'Time range' | translate}}">
              <span class="material-symbols-outlined">width</span>
              {{'X-Range' | translate}}
            </button>
            @if (isXAxisMenuOpen) {
              <div class="yaxis-menu">
                <div class="yaxis-control">
                  <label class="yaxis-control-label" for="xRangeStart">{{'Start' | translate}}</label>
                  <input #xStartInput id="xRangeStart" type="text" class="yaxis-input" [value]="xRangeStartText" [placeholder]="xRangeFormatHint">
                  <label class="yaxis-control-label" for="xRangeEnd">{{'End' | translate}}</label>
                  <input #xEndInput id="xRangeEnd" type="text" class="yaxis-input" [value]="xRangeEndText" [placeholder]="xRangeFormatHint">
                  <div class="yaxis-actions">
                    <button class="btn-ghost" (click)="applyXAxisRange(xStartInput.value, xEndInput.value)">{{'Apply' | translate}}</button>
                    <button class="btn-ghost" (click)="resetXAxisRange(xStartInput, xEndInput)">{{'Reset' | translate}}</button>
                  </div>
                </div>
                <div class="yaxis-hint">{{'Scroll on the graph to zoom the time axis.' | translate}}</div>
              </div>
            }
          </div>
          <button class="toolbar-btn" (click)="resetZoom()" title="{{'Zoom Fit' | translate}}">
            <span class="material-symbols-outlined">fit_screen</span>
          </button>
          <button class="toolbar-btn" (click)="exportData()" title="{{'Export' | translate}}">
            <span class="material-symbols-outlined">download</span>
          </button>
          <button class="toolbar-btn" (click)="toggleFullscreen()" title="{{(isFullscreenMode ? 'Exit Fullscreen' : 'Fullscreen') | translate}}">
            <span class="material-symbols-outlined">{{isFullscreenMode ? 'fullscreen_exit' : 'fullscreen'}}</span>
          </button>
        </div>
      </div>

      <!-- Multi-axis suggestion banner -->
      @if (showAxisBanner) {
        <div class="axis-banner" role="alert">
          <span class="material-symbols-outlined">info</span>
          <span>{{axisBannerMessage | translate: axisBannerParams}}</span>
          <button (click)="dismissAxisBanner()" class="btn-ghost">
            {{'Dismiss' | translate}}
          </button>
        </div>
      }

      @if (showAlertPeriodsLayer || showNotificationMarkersLayer) {
        <div class="alert-severity-legend">
          <span class="legend-title">{{'Severity scale' | translate}}:</span>
          <app-severity-chip [severity]="alertSeverityLevel.Watch" [compact]="true"></app-severity-chip>
          <app-severity-chip [severity]="alertSeverityLevel.Action" [compact]="true"></app-severity-chip>
          <app-severity-chip [severity]="alertSeverityLevel.Alert" [compact]="true"></app-severity-chip>
          <app-severity-chip [severity]="alertSeverityLevel.Critical" [compact]="true"></app-severity-chip>
        </div>
      }

      <!-- Legend row with axis toggle — horizontal, sits above the chart canvas -->
      @if (am5SeriesData?.length > 0) {
        <div class="chart-legend">
          @for (series of am5SeriesData; track trackByIndex(i); let i = $index) {
            <div class="legend-item" [class.legend-item-hidden]="series.hidden">
              <button type="button" class="legend-visibility-btn" (click)="toggleSeriesVisibility(i)" title="{{'Show on Graph' | translate}}">
                <div class="legend-line" [class.dashed]="series.parameterIndex > 0" [style.background-color]="series.parameterIndex > 0 ? 'transparent' : series.color" [style.color]="series.color"></div>
                <span class="legend-name">{{series.nodeName ? series.nodeName + ' · ' : ''}}{{series.paramName}}</span>
              </button>
              <span class="legend-meta">{{series.paramUnit}}</span>
              <div class="axis-toggle" title="{{'Assign to axis' | translate}}">
                <button class="axis-toggle-btn" [class.active]="series.axisAssignment === 'L'"
                (click)="setSeriesAxis(i, 'L')" title="{{'Left axis' | translate}}" aria-label="{{'Left axis' | translate}}">L</button>
                <button class="axis-toggle-btn" [class.active]="series.axisAssignment === 'R'"
                (click)="setSeriesAxis(i, 'R')" title="{{'Right axis' | translate}}" aria-label="{{'Right axis' | translate}}">R</button>
                <button class="axis-toggle-btn" [class.active]="series.axisAssignment === '3'"
                (click)="setSeriesAxis(i, '3')" title="{{'Third axis' | translate}}" aria-label="{{'Third axis' | translate}}">3</button>
              </div>
            </div>
          }
        </div>
      }

      <div class="chart-area">
        @if (!chartHasNoData) {
          <app-node-analytics-chart
            [seriesData]="am5SeriesData"
            [timeCursor]="currentTimeCursor"
            [notifications]="notificationPoints"
            [alertPeriods]="alertPeriods"
            [thresholds]="thresholdLines"
            [selectedRange]="selectedSectionRange"
            [noteRanges]="noteRanges"
            [selectedNoteId]="selectedCommentId"
            [showAlertPeriods]="showAlertPeriodsLayer"
            [showNotifications]="showNotificationMarkersLayer"
            [showThresholds]="showThresholdsLayer"
            [showNotes]="showNotesLayer"
            [showMinMaxBand]="showMinMaxBandLayer"
            [rangePickMode]="rangePickMode"
            (zoomChange)="onChartZoomChange($event)"
            (rangeSelection)="onChartRangeSelection($event)"
            (rangePicked)="onChartRangePicked($event)"
            (rangePickProgress)="onChartRangePickProgress($event)"
            (cursorMove)="setTimeCursor($event)"
            (plotBoundsChange)="onChartPlotBoundsChange($event)"
            (yAxisRangeChange)="onChartYAxisRangeChange()"
            class="main-chart">
          </app-node-analytics-chart>
        }
        @if (rangePickMode) {
          <div class="range-pick-hint">
            <span class="material-symbols-outlined">ads_click</span>
            <span class="range-pick-hint-text">
              {{ (rangePickFirstTs == null
              ? 'Click the first point on the graph to set the note start time'
              : 'Click the second point on the graph to set the note end time') | translate }}
            </span>
            <button class="range-pick-cancel" (click)="cancelRangePick()">{{'Cancel' | translate}}</button>
          </div>
        }
        @if (chartHasNoData) {
          <div class="no-data">{{'No Data Found' | translate}}</div>
        }
      </div>

      <app-node-sync-panel
        [videoResources]="videoResources"
        [sensorRecords]="loadedSensorRecords"
        [isMobileSensor]="showMapLayer && isMobileSensor"
        [timeCursor]="currentTimeCursor"
        [zoomRange]="lastZoom"
        [chartPlotBounds]="chartPlotBounds"
        (timeCursorChange)="setTimeCursor($event)"
        (zoomOut)="resetZoom()">
      </app-node-sync-panel>
    </div>

    <div class="analysis-panel" [class.collapsed]="isPanelCollapsed">

      <div class="panel-collapsed-rail">
        <button class="rail-btn" (click)="togglePanel()" title="{{'Expand panel' | translate}}">
          <span class="material-symbols-outlined">chevron_left</span>
        </button>
        <button class="rail-btn" [class.active]="activeTab === 'summary'" (click)="togglePanel(); switchTab('summary')" title="{{'Summary' | translate}}">
          <span class="material-symbols-outlined">insights</span>
        </button>
        <button class="rail-btn" [class.active]="activeTab === 'compare'" (click)="togglePanel(); switchTab('compare')" title="{{'Compare' | translate}}">
          <span class="material-symbols-outlined">compare</span>
        </button>
        <button class="rail-btn" [class.active]="activeTab === 'notes'" (click)="togglePanel(); switchTab('notes')" title="{{'Notes' | translate}}">
          <span class="material-symbols-outlined">note</span>
        </button>
      </div>

      <div class="panel-content">
        <div class="panel-header">
          <span class="panel-header-title">{{'Analysis' | translate}}</span>
          <button class="panel-collapse-btn" (click)="togglePanel()" title="{{'Collapse' | translate}}">
            <span class="material-symbols-outlined">chevron_right</span>
          </button>
        </div>

        <div class="panel-tabs">
          <button class="panel-tab" [class.active]="activeTab === 'summary'" (click)="switchTab('summary')" data-tab="summary">
            <span class="material-symbols-outlined">summarize</span>
            {{'Summary' | translate}}
          </button>
          <button class="panel-tab" [class.active]="activeTab === 'compare'" (click)="focusCompareTab()" data-tab="compare">
            <span class="material-symbols-outlined">compare_arrows</span>
            {{'Compare' | translate}}
            @if (compareNodes.length > 0) {
              <span class="panel-tab-count">{{compareNodes.length}}</span>
            }
          </button>
          <button class="panel-tab" [class.active]="activeTab === 'notes'" (click)="switchTab('notes')" data-tab="notes">
            <span class="material-symbols-outlined">edit_note</span>
            {{'Notes' | translate}}
            @if (comments?.length > 0) {
              <span class="panel-tab-count">{{comments.length}}</span>
            }
          </button>
        </div>

        <div class="panel-body">
          @if (activeTab === 'summary') {
            <div id="tab-summary" class="tab-pane">
              <div class="summary-section">
                <h4 class="section-label">{{'Series Statistics' | translate}}</h4>
                <div class="series-kpi-cards">
                  @for (param of paramValues; track trackByIndex($index)) {
                    <div class="series-kpi-card">
                      <div class="series-kpi-header">
                        <span class="series-kpi-name">{{param.paramName}} ({{param.nodeLabel || endPointName}})</span>
                        <span class="series-kpi-source">{{param.unit}}</span>
                      </div>
                      <div class="series-kpi-grid">
                        <div class="kpi-cell">
                          <span class="kpi-cell-label">{{'Avg' | translate}}</span>
                          <span class="kpi-cell-value">{{param.average | number:'1.0-2'}}</span>
                        </div>
                        <div class="kpi-cell">
                          <span class="kpi-cell-label">{{'Peak' | translate}}</span>
                          <span class="kpi-cell-value">{{param.peak | number:'1.0-2'}}</span>
                        </div>
                        <div class="kpi-cell">
                          <span class="kpi-cell-label">{{'Count' | translate}}</span>
                          <span class="kpi-cell-value">{{param.count || '-'}}</span>
                        </div>
                      </div>
                    </div>
                  }
                </div>
              </div>
              <div class="metadata-section">
                <div class="metadata-card">
                  <h5 class="metadata-label">{{'Device' | translate}}</h5>
                  <div class="metadata-grid">
                    <div class="metadata-item">
                      <span class="metadata-item-label">{{'Device Name' | translate}}</span>
                      <span class="metadata-item-value">{{nodeDetails?.deviceName}}</span>
                    </div>
                    <div class="metadata-item">
                      <span class="metadata-item-label">{{'Device ID' | translate}}</span>
                      <span class="metadata-item-value">{{nodeDetails?.deviceId}}</span>
                    </div>
                  </div>
                </div>
                @if (nodeDetails?.lastReading && nodeDetails?.lastReading !== '-') {
                  <div class="last-reading-header">
                    <span class="last-reading-label">{{'Last Reading' | translate}}</span>
                    <span class="last-reading-time">{{nodeDetails?.lastReading}}</span>
                  </div>
                }
                <div class="metadata-card">
                  <h5 class="metadata-label">{{'Analyte Reading' | translate}}</h5>
                  <p class="metadata-value">{{nodeDetails?.analyteValue}}</p>
                </div>
                <div class="metadata-card">
                  <h5 class="metadata-label">{{'Network & Battery' | translate}}</h5>
                  <div class="metadata-grid">
                    <div class="metadata-item">
                      <span class="metadata-item-label">{{'Signal' | translate}}</span>
                      <span class="metadata-item-value">{{nodeDetails?.signalStrength}}</span>
                    </div>
                    <div class="metadata-item">
                      <span class="metadata-item-label">{{'Battery' | translate}}</span>
                      <span class="metadata-item-value">{{nodeDetails?.batteryPercentage}}</span>
                    </div>
                  </div>
                </div>
                <div class="metadata-card">
                  <h5 class="metadata-label">{{'Environment' | translate}}</h5>
                  <div class="metadata-grid">
                    <div class="metadata-item">
                      <span class="metadata-item-label">{{'Temp' | translate}}</span>
                      <span class="metadata-item-value">{{nodeDetails?.temperature}}</span>
                    </div>
                    <div class="metadata-item">
                      <span class="metadata-item-label">{{'Humidity' | translate}}</span>
                      <span class="metadata-item-value">{{nodeDetails?.humidity}}</span>
                    </div>
                    <div class="metadata-item">
                      <span class="metadata-item-label">{{'Pressure' | translate}}</span>
                      <span class="metadata-item-value">{{nodeDetails?.pressure}}</span>
                    </div>
                  </div>
                </div>
                <div class="metadata-card">
                  <h5 class="metadata-label">{{'Wind' | translate}}</h5>
                  <div class="metadata-grid">
                    <div class="metadata-item">
                      <span class="metadata-item-label">{{'Speed' | translate}}</span>
                      <span class="metadata-item-value">{{nodeDetails?.windSpeed}} {{nodeDetails?.windSpeedUnit}}</span>
                    </div>
                    <div class="metadata-item">
                      <span class="metadata-item-label">{{'Direction' | translate}}</span>
                      <div class="direction-compass">
                        <img src="./assets/images/direction-circle.svg" class="compass-bg">
                        <img src="./assets/images/direction-icon.svg" class="compass-needle" [style.transform]="windDirectionTransform">
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          }

          @if (activeTab === 'compare') {
            <div id="tab-compare" class="tab-pane">
              <app-compare-tab
                [endPoints]="endPoints || []"
                [selectedEndPoints]="selectedEndPoints"
                [lockedEndpointId]="endPointId"
                (selectionChange)="onCompareSelectionChange($event)"
                (apply)="applyCompare()"
                (clearAll)="clearCompare()">
              </app-compare-tab>
            </div>
          }

          @if (activeTab === 'notes') {
            <div id="tab-notes" class="tab-pane">
              <button class="btn btn-sm btn-primary notes-add-btn" [class.picking]="isAddingNote" (click)="enableCommentCreation()">
                <span class="material-symbols-outlined">{{ isAddingNote ? 'close' : 'add' }}</span>
                {{ (isAddingNote ? 'Cancel' : 'Add Note') | translate }}
              </button>
              @if (isLoadingNotes) {
                <app-rings-loader></app-rings-loader>
              }
              @if (!isLoadingNotes && comments?.length === 0) {
                <div class="no-notes-message">
                  <span class="material-symbols-outlined">note_alt</span>
                  <p>{{'No notes yet' | translate}}</p>
                </div>
              }
              @if (!isLoadingNotes) {
                @for (comment of comments; track trackByIndex($index)) {
                  <div class="annotation-card" (click)="selectCommentRange(comment)">
                    <div class="annotation-time">
                      <span class="annotation-time-label">
                        <span class="material-symbols-outlined">schedule</span>
                        {{comment.fromDate * 1000 | date: 'short'}}
                      </span>
                      <button *objectHasPermission="commentPermissionObject; action: deleteAction" class="annotation-delete-btn" (click)="$event.stopPropagation(); deleteComment(comment.id)" title="{{'Delete' | translate}}">
                        <span class="material-symbols-outlined">close</span>
                      </button>
                    </div>
                    <p class="annotation-text">{{comment.text}}</p>
                  </div>
                }
              }
            </div>
          }
        </div>
      </div>
    </div>
  </div>

